import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from '@webs/components-library/theming';

@customElement('webs-card-contact')
export class CardContact extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-card-contact {
        background: var(--color-light-grey);
        color: var(--color-dark-grey);
        border-radius: 8px;
        padding: 30px 10px 28px 24px;

        font-weight: normal;
      }

      .m-card-contact__email,
      .m-card-contact__quoter-info {
       font-family: var(--font-family-alternative);
      }

      .m-card-contact__quoter {
         display: flex;
         align-items: center;
      }

      .m-card-contact__quoter-info {
      }

       .m-card-contact__quoter--avatar {
        display: block;
        margin-right: 30px;

      }

      .m-card-contact .image {
        display: block;
        height: auto;
        width: 100%;
        border-radius: 50%;
         width: 48px;
        height: 48px;
      }

      .m-card-contact__quoter-info--name {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        margin: 0;
      }

      .m-card-contact__quoter-info--extra-info {
        margin: 0;
        font-size: 14px;
        line-height: 22px;
        opacity: 0.6;
      }

     .m-card-contact__email {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 0;
        margin-top: 25px;
        color: var(--color-dark-grey);
        text-decoration: none;
        display: block;
     }

     .m-card-contact__phone {
        font-size: 16px;
        line-height: 22px;
        margin: 0;
        color: var(--color-dark-grey);
        text-decoration: none;
     }

     .m-card-contact__quote {
        font-size: 16px;
        line-height: 1.5rem;
     }

    `,
  ];

  @property({attribute: 'avatar-src'})
  avatarSrc: string;

  @property({attribute: 'avatar-alt'})
  avatarAlt: string;

  @property({attribute: 'quoter-name'})
  quoterName: string;

  @property({attribute: 'extra-info'})
  extraInfo: string;

  @property()
  email: string;

  @property()
  phone: string;

  @property()
  quote: string;


  protected render(): unknown {
    return html`
      <div class="m-card-contact">
        <div class="m-card-contact__quoter">
          ${this.avatarSrc ? html`
            <picture class="m-card-contact__quoter--avatar">
              <img src="${this.avatarSrc}" alt="${this.avatarAlt}" class="image" loading="lazy" width="60"/>
            </picture>
          ` : ''
          }
          <div class="m-card-contact__quoter-info">
            ${this.quoterName ? html`<h6 class="m-card-contact__quoter-info--name">${this.quoterName}</h6>` : ''}
            ${this.extraInfo ? html`<p class="m-card-contact__quoter-info--extra-info">${this.extraInfo}</p>` : ''}
          </div>
        </div>
        ${this.email ? html`<a class="m-card-contact__email" href="mailto:${this.email}">${this.email}</a>` : ''}
        ${this.phone ? html`<a class="m-card-contact__phone" href="tel:${this.phone}">${this.phone}</a>` : ''}
        ${this.quote ? html`<p class="m-card-contact__quote">${this.quote}</p>` : ''}
      </div>
    `
  }
}
